export default {"src":"/_next/static/media/Inter.690241b0.svg","height":840,"width":840,"blurWidth":0,"blurHeight":0};